import styled from 'styled-components'
import { Navbar } from '@sketch/components'

export const Item = styled.div`
  margin: 0 8px;
`

export const FooterNavbar = styled(Navbar).attrs({
  alignItems: 'space-between',
})`
  border-top: 1px solid ${({ theme }) => theme.colors.border.A};
`
